import React from 'react';

import t_logs from 'modules/log/t-logs';
import tlogs_es from 'modules/log/t-logs_es';
import { StyledInline } from 'modules/log/LogItem/styled';
import { IS_TENANT } from 'tenant/config';

const ActionName = ({ action, ...props }) => {
  const logs_messages = IS_TENANT ? tlogs_es : t_logs;
  return <StyledInline {...props}>{logs_messages.action_names[action] || action}</StyledInline>;
};

export default ActionName;
